export class AppConstants {
    // Session Storage Constants
    public static SESSION_STORAGE_CURRENT_USER_CONTEXT = "current-user-context";
    public static SESSION_STORAGE_ACCESS_TOKEN = "access-token";
    public static SESSION_STORAGE_EXTERNAL_USER_CONTEXT = "external-user-context";
    public static SESSION_STORAGE_CLICKED_TAB = "clicked-tab";
    public static SESSION_STORAGE_TENANTID = 0;
    public static SESSION_STORAGE_ROLEID = 3;
    public static CONFIRMATION_ID = "confirmationId";
    public static SESSION_STORAGE_PAYMENT_SOURCE = "payment-source";
    public static PAYMENT_SOURCE_ADMIN_BOOKING = "adminBooking";

    // Status
    public static STATUS_ACTIVE = 'Active';
    public static STATUS_INACTIVE = 'Inactive';

    public static TAB_ADMIN_BOOKINGS = "admin-bookings";
    public static TAB_TRANSACTIONS = "transactions";
    public static TAB_PROFILE = "profile";
    public static TAB_REPORTS = "reports";
    public static TAB_DASHBOARD = "dashboard";
    public static TAB_COMPANY_PROFILE = "company-profile";
    public static TAB_PRODUCTS = "products";
    public static TAB_VENUES = "venues";
    public static TAB_THEMES = "themes";
    public static TAB_POLICY = "policy";
    public static TAB_EXCEPTIONS = "exceptions";

    public static OTP_TYPE_EMAIL = "email";

    public static PHONE_NUMBER_PREFIX = "+91-";

    public static SINGLE_SESSION = "Single Session";
    public static MULTI_SESSION = "Multi Session";
    // product_type of add-on products (must match the backend Constants.PRODUCT_TYPE_ADD_ONS)
    public static ADD_ONS = "Add-On";


    //iCons
    public static readonly SERVICE_TYPE_NAMES = {

      'badminton2.svg': 'Badminton',
      'Tennis.svg': 'Tennis',
      'Pickleball_small.svg': 'Pickleball',
      'paddle.svg': 'Paddle',
      'Squash.svg': 'Squash',
      'TableTennis.svg': 'Table Tennis',

      'cricket.svg': 'Cricket',
      'football2.svg': 'Football',
      'basketball.svg': 'Basketball',
      'Volleyball.svg': 'Volleyball',

      'Swimming.svg': 'Swimming',

      'gym.svg': 'Gym & Fitness',
      'gymnastics.svg': 'Gymnastics',
      'Yoga.svg': 'Yoga',
      'MartialArts.svg': 'Martial Arts',

      'Skating.svg': 'Skating',
      'chess.svg': 'Chess',
      'Athletics.svg': 'Athletics',
      'cycling.svg': 'Cycling',
      'Archery.svg': 'Archery',
      'golf.svg': 'Golf',
      'climbing.svg': 'Climbing',

      'coach.svg': 'Coaching'
    };

      public static readonly DEFAULT_SERVICE_ICON =
        '../../assets/img/coach.svg';


      public static getServiceIcon(serviceType: string): string {

        return AppConstants.SERVICE_TYPE_NAMES[serviceType]
            || AppConstants.SERVICE_TYPE_NAMES;
      }
      public static getServiceName(serviceTypeIcon: string): string {

        return AppConstants.SERVICE_TYPE_NAMES[serviceTypeIcon]
            || serviceTypeIcon?.replace('.svg', '');
      }
}


